export default class SpeechSynthesis {
  constructor({lang, useLocalService, voiceName, pitch, rate, volume} = SpeechSynthesis.defaultConfig) {
    this.config = {
      lang: lang,
      useLocalService: useLocalService,
      voiceName: voiceName,
      pitch: pitch,
      rate: rate,
      volume: volume,
    }

    if (this.checkAble()) {
      this.speechSynthesis = window.speechSynthesis;
      this.voices = this.speechSynthesis.getVoices();
      this.voice = null;

      //确定播放的语音库
      //优先使用指定语音
      if (voiceName !== null) {
        this.voice = (this.voices || []).find(voice => {
          return voice.name == voiceName;
        })
      }
      if (this.voice == null) {
        (this.voices || []).forEach(voice => {
          if ((useLocalService === voice.localService) && (lang === voice.lang)) {
            this.voice = voice;
          }
        })
      }
    }

  }

  checkAble() {
    if ('speechSynthesis' in window) {
      return true;
    } else {
      return false;
    }
  }

  setConfig({lang, useLocalService, voiceName, pitch, rate, volume}) {
    if (lang) {
      this.config.lang = lang;
    }
    if (useLocalService) {
      this.config.useLocalService = useLocalService;
    }
    if (pitch) {
      this.config.pitch = pitch;
    }
    if (rate) {
      this.config.rate = rate;
    }
    if (volume) {
      this.config.volume = volume;
    }
  }

  setDefaultConfig() {
    this.config = SpeechSynthesis.defaultConfig;
  }

  play(text) {
    if (!this.checkAble) {
      return
    }
    this.cancel();
    let to_speak = new SpeechSynthesisUtterance(text);
    if (this.voice) {
      to_speak.voice = this.voice;
    }
    if (this.config.pitch) {
      to_speak.pitch = this.config.pitch;
    }
    if (this.config.rate) {
      to_speak.rate = this.config.rate;
    }
    if (this.config.volume) {
      to_speak.volume = this.config.volume;
    }
    this.speechSynthesis.speak(to_speak);

  }

  //暂停
  pause() {
    if (!this.checkAble) {
      return
    }
    this.speechSynthesis.pause();
  }

  //继续播放
  resume() {
    if (!this.checkAble) {
      return
    }
    this.speechSynthesis.resume(); //继续
  }

  //清除所有语音播报创建的队列
  cancel() {
    if (!this.checkAble) {
      return
    }
    this.speechSynthesis.cancel();
  }

}

SpeechSynthesis.defaultConfig = {
  lang: 'zh-CN',//语言
  useLocalService: true,//使用本地库
  voiceName: null,//语音库名
  pitch: 1,//音调 范围0-2
  rate: 0.6,//速度 范围0.1-10
  volume: 1,//音量 范围0-1
}



// WEBPACK FOOTER //
// ./src/utils/speechSynthesis.js